// extracted by mini-css-extract-plugin
module.exports = {"end-shift":"components-ContentHeader-Unassign-Unassign__end-shift--2iddC"};